import { render, staticRenderFns } from "./LogisticTraceabilityBatches.vue?vue&type=template&id=9c399c9c&scoped=true"
import script from "./LogisticTraceabilityBatches.vue?vue&type=script&lang=js"
export * from "./LogisticTraceabilityBatches.vue?vue&type=script&lang=js"
import style0 from "./LogisticTraceabilityBatches.vue?vue&type=style&index=0&id=9c399c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c399c9c",
  null
  
)

export default component.exports